// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment sessionFragment on Session {
    _id
    title
    sessionDate
    sessionTime
    category
    sessionType {
      _id
      title
      color
    }
    description
    client {
      _id
      firstName
      lastName
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/sessionFragment.js